import React, { useState, useEffect } from 'react';
import Icon from 'components/AppIcon';

export default function NetworkStatusBanner() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBackOnline, setShowBackOnline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowBackOnline(true);
      setTimeout(() => setShowBackOnline(false), 3000);
    };
    const handleOffline = () => {
      setIsOnline(false);
      setShowBackOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline && !showBackOnline) return null;

  if (showBackOnline) {
    return (
      <div
        className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-2 py-2 text-sm"
        style={{ backgroundColor: 'var(--color-success)', color: 'white', fontFamily: 'var(--font-caption)' }}
      >
        <Icon name="Wifi" size={14} color="white" />
        Back online
      </div>
    );
  }

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-2 py-2 text-sm"
      style={{ backgroundColor: '#92400E', color: 'white', fontFamily: 'var(--font-caption)' }}
    >
      <Icon name="WifiOff" size={14} color="white" />
      You are offline — some features may not work
    </div>
  );
}
